import { IconFollow, IconFollowed } from "../Icon";
import { select } from "../../utils/components";

export default select(
    new Map([
        [false, IconFollow],
        [true, IconFollowed],
    ])
);
